import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';

import useStyles from './styles';

const colors = {
  primary:   'Primary',
  secondary: 'Secondary',
  success:   'Success',
  second:    'Second',
  warning: 'Warning',
  error:  'Error',
  blue:   'Primary',
  purple: 'Second',
  green:  'Success',
  orange: 'Warning',
  red:    'Error',
  black: 'Black',
  grey:  'Grey',
  rose:  'Rose',
  falta: 'Falta',
};

function CustomButton(props) {
  const classesDefault = useStyles();

  const {
    color,
    classes,
    ...ownProps
  } = props;

  return (
    <Button
      color="default"
      {...ownProps}
      classes={{
        text: classesDefault[`text${colors[color]}`],
        outlined: classesDefault[`outlined${colors[color]}`],
        contained: classesDefault[`contained${colors[color]}`],
        ...classes,
      }}
    />
  );
}

CustomButton.defaultProps = {
  ...Button.defaultProps,
  color: 'primary',
  variant: 'contained',
};

CustomButton.propTypes = {
  ...Button.propTypes,
  color: PropTypes.oneOf([
    'primary',
    'second',
    'success',
    'warning',
    'error',
    'blue',
    'purple',
    'green',
    'orange',
    'red',
    'secondary',
    'black',
    'grey',
    'rose',
    'falta',
  ]),
};

export default memo(CustomButton);

